module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-block"
  }, [_c('h4', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "href": _vm.apiDomain,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(_vm._s(_vm.document.title))])]), _vm._v(" "), (_vm.sharingEnabled) ? _c('span', {
    staticClass: "toolbar"
  }, [_c('a', {
    staticClass: "action",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateSelected($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-square-o"
  })])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a3fbc7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DocumentItem.vue
// module id = 281
// module chunks = 1